import React from "react";
import {PageWrapper} from "../components/global/PageWrapper";

export const Dashboard = props => {
    return <PageWrapper className="dashboard">
    </PageWrapper>
}
